import { useState, useEffect } from 'react';

export default function IconHero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="bg-white pt-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-24 lg:py-32">
        <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">
          {/* テキストエリア */}
          <div
            className="w-full lg:w-[55%]"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
              transition: 'opacity 1000ms ease-out, transform 1000ms ease-out',
            }}
          >
            <span
              className="inline-block font-medium text-xs md:text-sm tracking-[0.2em] uppercase"
              style={{ color: '#3E5F8F' }}
            >
              ICON White Spot Treatment
            </span>
            <div className="w-8 h-px mt-3 mb-4" style={{ backgroundColor: '#3E5F8F' }}></div>

            <h1 className="font-serif text-gray-900 text-2xl md:text-4xl lg:text-5xl leading-relaxed lg:leading-relaxed">
              もうホワイトスポットで<br />笑顔を隠さない。
            </h1>

            {/* モバイル用画像 */}
            <div className="lg:hidden mt-6">
              <div className="rounded-lg overflow-hidden aspect-[3/4] max-h-[400px]">
                <img
                  alt="ICON白斑治療後の自然な美しい歯"
                  className="w-full h-full object-cover object-top"
                  src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/bca5f3270a0e97fcc212cf37497cd72f.png"
                />
              </div>
            </div>

            <p className="font-light text-gray-500 text-sm md:text-base mt-6 leading-loose">
              前歯のホワイトスポット、ずっと気になっていませんか?<br />
              ICONなら麻酔なし・痛みなし・1回の通院で改善できます。
            </p>

            <div className="flex flex-wrap items-center gap-2 mt-6 text-gray-500 font-light text-sm">
              <span>削らない</span>
              <span className="text-gray-300">/</span>
              <span>麻酔不要</span>
              <span className="text-gray-300">/</span>
              <span>1回完結</span>
              <span className="text-gray-300">/</span>
              <span>痛みなし</span>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center text-white font-medium text-sm px-6 py-3 rounded-full whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity duration-200"
                style={{ backgroundColor: '#3E5F8F' }}
              >
                無料カウンセリングを予約する
              </a>
              <a
                href="#about"
                className="inline-flex items-center justify-center bg-white font-medium text-sm px-6 py-3 rounded-full border whitespace-nowrap cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                style={{ color: '#3E5F8F', borderColor: '#3E5F8F' }}
              >
                詳しく見る
              </a>
            </div>
          </div>

          {/* デスクトップ用画像 */}
          <div
            className="w-full lg:w-[45%] hidden lg:block"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
              transition: 'opacity 1200ms ease-out 300ms, transform 1200ms ease-out 300ms',
            }}
          >
            <div className="rounded-lg overflow-hidden aspect-[3/4]">
              <img
                alt="ICON白斑治療後の自然な美しい歯"
                className="w-full h-full object-cover object-top"
                src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/bca5f3270a0e97fcc212cf37497cd72f.png"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}